/**
 * Logikk for Konfliktrisiko-analyse (CRI)
 */

export const CONFLICT_DIMENSIONS = [
  { id: 'tension', name: 'Spenning', icon: 'Zap', desc: 'Grad av interpersonell friksjon.' },
  { id: 'comm_breakdown', name: 'Kommunikasjon', icon: 'MessageX', desc: 'Brudd i informasjonsflyt.' },
  { id: 'unresolved', name: 'Uavklarte feider', icon: 'AlertCircle', desc: 'Gamle konflikter som ulmer.' },
  { id: 'trust', name: 'Mistillit', icon: 'ShieldOff', desc: 'Manglende tro på andres motiver.' },
  { id: 'role_clash', name: 'Rolleuklarhet', icon: 'UserX', desc: 'Konflikt om ansvar og mandat.' },
  { id: 'fairness', name: 'Urettferdighet', icon: 'Scale', desc: 'Opplevelse av forskjellsbehandling.' }
];

export const getCRICategory = (score) => {
  if (score >= 75) return { label: 'Kritisk risiko', color: 'rose', status: 'Critical' };
  if (score >= 50) return { label: 'Høy risiko', color: 'orange', status: 'High' };
  if (score >= 25) return { label: 'Moderat risiko', color: 'amber', status: 'Moderate' };
  return { label: 'Lav risiko', color: 'emerald', status: 'Low' };
};

export const conflictTeamData = [
  { id: 't1', name: 'Logistikk-avd', cri: 78, scores: { tension: 85, comm_breakdown: 70, unresolved: 90, trust: 65, role_clash: 80, fairness: 78 } },
  { id: 't2', name: 'IT-Utvikling', cri: 12, scores: { tension: 10, comm_breakdown: 15, unresolved: 5, trust: 10, role_clash: 20, fairness: 12 } },
  { id: 't3', name: 'Salg Sør', cri: 54, scores: { tension: 60, comm_breakdown: 45, unresolved: 40, trust: 55, role_clash: 65, fairness: 59 } },
  { id: 't4', name: 'HR & Adm', cri: 32, scores: { tension: 25, comm_breakdown: 35, unresolved: 30, trust: 28, role_clash: 40, fairness: 34 } }
];

export const getMediationActions = (team) => {
  const strategies = [];
  const prevention = [];

  if (team.scores.tension > 70) {
    strategies.push("Gjennomføre fasilitert dialogmøte med nøytral tredjepart.");
    prevention.push("Innføre ukentlige 'ventilasjonsmøter' med fokus på prosess, ikke person.");
  }
  if (team.scores.role_clash > 60) {
    strategies.push("Rolleavklaring-workshop (RACI-matrise revisjon).");
    prevention.push("Gjennomgang av stillingsinstrukser og beslutningsmandater.");
  }
  if (team.scores.fairness > 60) {
    strategies.push("Ledercoaching med fokus på objektiv ressursfordeling.");
    prevention.push("Etablere transparente kriterier for bonuser og oppgaver.");
  }

  return {
    mediation: strategies.length > 0 ? strategies : ["Ingen akutte behov for mekling."],
    prevention: prevention.length > 0 ? prevention : ["Fortsett med dagens gode konfliktkultur."]
  };
};